var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { get } from "../../utils/idb.js";
import { IMAGE_UPDATE_EVENT_TYPE } from "../../constants.js";
import ElementController from "../base-controllers/ElementController.js";
import { value } from "../base-controllers/element_controller/value_decorator.js";
import { resizeImageSrcToDataURL } from "../utils/image.js";
class SyncImage extends ElementController {
    constructor() {
        super(...arguments);
        this.refreshGeneration = 0;
        this.setItemSrc = async () => {
            const uuid = this.uuid;
            const generation = this.refreshGeneration;
            const previousSrc = this.root.src;
            const item = await get("sync-file", uuid);
            if (item) {
                const preview = await resizeImageSrcToDataURL(item.data, this.root.width, this.root.height, "fill");
                // Completion or a newer morph can win while IndexedDB/image decoding is
                // pending. Never put the old local preview over the refreshed original.
                if (!this.root.isConnected || this.uuid !== uuid || this.root.src !== previousSrc || generation !== this.refreshGeneration)
                    return;
                this.imgSrc = preview;
                this.setImgSrc();
            }
        };
        this.setImgSrc = () => {
            this.root.setAttribute("src", this.imgSrc);
        };
        this.handleSyncItemAdded = (event) => {
            if (this.uuid === event.detail.key)
                void this.setItemSrc();
        };
        this.handleSyncItemRemoved = (event) => {
            if (this.uuid === event.detail.key) {
                this.imgSrc = this.originalSrc;
                this.setImgSrc();
            }
        };
    }
    async init() {
        this.on(this.root, IMAGE_UPDATE_EVENT_TYPE, () => { this.refreshGeneration++; });
        this.setItemSrc();
        this.onGlobal("syncItemRemoved", this.handleSyncItemRemoved);
        this.onGlobal("syncItemAdded", this.handleSyncItemAdded);
    }
    get root() {
        return super.root;
    }
    uuidChanged(value, oldValue) {
        if (oldValue && value !== oldValue) {
            this.refreshGeneration++;
            if (value)
                void this.setItemSrc();
        }
    }
}
SyncImage.id = "SyncImage";
export default SyncImage;
__decorate([
    value(String)
], SyncImage.prototype, "uuid", void 0);
__decorate([
    value(String)
], SyncImage.prototype, "originalSrc", void 0);
//# sourceMappingURL=SyncImage.js.map